import { render, staticRenderFns } from "./LabelPrintTrigger.vue?vue&type=template&id=57af31b6&scoped=true&"
import script from "./LabelPrintTrigger.vue?vue&type=script&lang=js&"
export * from "./LabelPrintTrigger.vue?vue&type=script&lang=js&"
import style0 from "./LabelPrintTrigger.vue?vue&type=style&index=0&id=57af31b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57af31b6",
  null
  
)

export default component.exports